import { gql } from '@apollo/client';

/**
 * ТЗ 0112 (#155) — записи документов. Шаблоны — только Admin; выпуск —
 * роли карточки студента / группы. Имена операций ≠ полям бэкенда.
 */

export const CreateDocTemplateMutation = gql`
  mutation CreateDocTemplate(
    $name: String!
    $kind: String
    $scope: String
    $basedOnId: ID
    $legalEntityId: ID
  ) {
    createDocumentTemplate(
      name: $name
      kind: $kind
      scope: $scope
      basedOnId: $basedOnId
      legalEntityId: $legalEntityId
    ) {
      success
      customErrors {
        field
        code
        message
      }
      problems {
        code
        message
        token
      }
      template {
        id
        code
        name
        kind
        scope
        isActive
        legalEntityId
        legalEntityName
        version
        currentVersionId
        createdAt
        updatedAt
        updatedByName
        versions {
          id
          version
          origin
          comment
          createdAt
          createdByName
          isCurrent
        }
      }
    }
  }
`;

export const StoreDocTemplateMutation = gql`
  mutation StoreDocTemplate(
    $id: ID!
    $html: String
    $name: String
    $comment: String
  ) {
    saveDocumentTemplate(id: $id, html: $html, name: $name, comment: $comment) {
      success
      customErrors {
        field
        code
        message
      }
      problems {
        code
        message
        token
      }
      template {
        id
        code
        name
        kind
        scope
        isActive
        legalEntityId
        legalEntityName
        version
        currentVersionId
        createdAt
        updatedAt
        updatedByName
        versions {
          id
          version
          origin
          comment
          createdAt
          createdByName
          isCurrent
        }
      }
    }
  }
`;

export const ToggleDocTemplateMutation = gql`
  mutation ToggleDocTemplate($id: ID!, $active: Boolean!) {
    setDocumentTemplateActive(id: $id, active: $active) {
      success
      customErrors {
        field
        code
        message
      }
      template {
        id
        code
        name
        kind
        scope
        isActive
        legalEntityId
        legalEntityName
        version
        currentVersionId
        createdAt
        updatedAt
        updatedByName
        versions {
          id
          version
          origin
          comment
          createdAt
          createdByName
          isCurrent
        }
      }
    }
  }
`;

export const SwitchDocTemplateVersionMutation = gql`
  mutation SwitchDocTemplateVersion($versionId: ID!) {
    activateDocumentTemplateVersion(versionId: $versionId) {
      success
      customErrors {
        field
        code
        message
      }
      template {
        id
        code
        name
        kind
        scope
        isActive
        legalEntityId
        legalEntityName
        version
        currentVersionId
        createdAt
        updatedAt
        updatedByName
        versions {
          id
          version
          origin
          comment
          createdAt
          createdByName
          isCurrent
        }
      }
    }
  }
`;

export const IssueDocPdfMutation = gql`
  mutation IssueDocPdf(
    $templateId: ID!
    $studentId: ID
    $agreementId: ID
    $groupId: ID
    $issuePlace: String
  ) {
    issueDocument(
      templateId: $templateId
      studentId: $studentId
      agreementId: $agreementId
      groupId: $groupId
      issuePlace: $issuePlace
    ) {
      success
      customErrors {
        field
        code
        message
      }
      issuedDocument {
        id
        number
        kind
        scope
        templateId
        templateName
        templateVersion
        studentId
        studentName
        agreementId
        agreementTitle
        groupId
        groupName
        issueDate
        issuePlace
        issuedAt
        issuedByName
        missingFields
        hiddenFields
        hasFile
        sends {
          id
          sentAt
          sentTo
          sentByName
          mailboxEmail
          conversationId
        }
      }
      file {
        fileName
        contentType
        contentBase64
      }
      missingFields {
        code
        label
        labelPl
      }
      hiddenFields {
        code
        label
        labelPl
      }
    }
  }
`;

/**
 * ТЗ 0112 §4 — отправить выданный документ письмом (PDF во вложении) с ящика
 * школы; письмо ложится в переписку студента. Только по явной кнопке.
 */
export const SendIssuedDocPdfMutation = gql`
  mutation SendIssuedDocPdf(
    $issuedDocumentId: ID!
    $to: String
    $subject: String
    $html: String
    $mailboxEmail: String
  ) {
    sendIssuedDocument(
      issuedDocumentId: $issuedDocumentId
      to: $to
      subject: $subject
      html: $html
      mailboxEmail: $mailboxEmail
    ) {
      success
      customErrors {
        field
        code
        message
      }
      conversationId
      send {
        id
        sentAt
        sentTo
        sentByName
        mailboxEmail
        conversationId
      }
      issuedDocument {
        id
        hasFile
        sends {
          id
          sentAt
          sentTo
          sentByName
          mailboxEmail
          conversationId
        }
      }
    }
  }
`;
